export const clientTypeConstants = {
    INTERACTION_CLIENT: 'INTERACTION_CLIENT',
    INTERACTION_PRESENTER: 'INTERACTION_PRESENTER',
    INTERACTION_MODERATOR: 'INTERACTION_MODERATOR',
    INTERACTION_MEETING: 'INTERACTION_MEETING',
    INTERACTION_STAGE: 'INTERACTION_STAGE',
    INTERACTION_CHAT_MODERATOR: 'INTERACTION_CHAT_MODERATOR',
    INTERACTION_EXHIBITOR_HOST: 'INTERACTION_EXHIBITOR_HOST',
    INTERACTION_EXHIBITOR_VISITOR: 'INTERACTION_EXHIBITOR_VISITOR',
    INTERACTION_EDITOR: 'INTERACTION_EDITOR',
    INTERACTION_VONAGE_SPEAKER: 'INTERACTION_VONAGE_SPEAKER',
    INTERACTION_VONAGE_VIDEOWALL: 'INTERACTION_VONAGE_VIDEOWALL',
    INTERACTION_PLAUDIT_PRESENTER: 'INTERACTION_PLAUDIT_PRESENTER',
    INTERACTION_CHANNEL_LIST: 'INTERACTION_CHANNEL_LIST'
}